import presetListViewTemplate from '../../../../../Template/config/components/selection/PresetSelect'
import presetListView from './PresetListView'
const presetSelect = {
  ...presetListViewTemplate,
  presetListView
}

export default presetSelect
export { presetSelect }
